import { createContext } from "react";

const DomainContext = createContext();

export default DomainContext;
